export default "__VITE_ASSET__fP9B7Q2h__"